import { ChevronRight } from 'lucide-react';
import { StackedCellText } from '@/components/common/DataTable';
import { WorkTypeBadge } from '@/components/common/WorkTypeBadge';
import { cn } from '@/lib/utils';
import { DRILL_DOWN_CHIP_CLASS, DRILL_DOWN_CHIP_ICON_CLASS } from '@/styles/drillDownChip';

const DETAILS_CHIP_CLASS = cn(DRILL_DOWN_CHIP_CLASS, 'mt-1 text-xs');

interface WorkTypeCellProps {
  code: string | null;
  name: string | null;
  onOpenDetails: () => void;
}

export function WorkTypeCell({ code, name, onOpenDetails }: WorkTypeCellProps) {
  return (
    <StackedCellText
      primary={<WorkTypeBadge code={code} name={name} />}
      tertiary={
        <button
          type="button"
          className={DETAILS_CHIP_CLASS}
          aria-label={`See details of the ${name ?? 'DCR'} entry`}
          onClick={onOpenDetails}
        >
          Details
          <ChevronRight className={DRILL_DOWN_CHIP_ICON_CLASS} aria-hidden />
        </button>
      }
    />
  );
}
